import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/base/compary/findByPage",
        method: "post",
        data
    });
}

/**
 * 初始化区位树
 */
export function FetchStorageAreaTree() {
    return request({
        url: "/base/compary/getStorageAreaInfoTree",
        method: "post",
    });
}


export function FetchFindById(data) {
    return request({
        url: "/base/compary/getBaseComparyInfoById",
        method: "post",
        data
    });
}
//申请企业注册
export function RegisteredCompary(data) {
  return request({
      url: "/base/registered/registeredCompary",
      method: "post",
      data
  });
}
//发送短信
export function SendSMS(data) {
  return request({
      url: "/base/registered/sendSMS",
      method: "post",
      data
  });
}
//验证验证码
export function VerifyCode(data) {
  return request({
      url: "/base/registered/verifyCode",
      method: "post",
      data
  });
}
//保存企业信息
export function SaveComparyInfo(data) {
  return request({
      url: "/base/compary/saveComparyInfo",
      method: "post",
      data
  });
}
//删除企业信息
export function DeletComparyInfoByIds(data) {
  return request({
      url: "/base/compary/deletComparyInfoByIds",
      method: "post",
      data
  });
}
//校验企业名称信用代码唯一性
export function CheckComparyNameAndCode(data) {
  return request({
      url: "/base/registered/checkComparyNameAndCode",
      method: "post",
      data
  });
}
// 获取企业类型
export function getDictByDicTypeKey(data) {
  return request({
      url: "base/dictionary/getDictByDicTypeKey",
      method: "post",
      data
  });
}